import { FormSchema } from "../FormBuilder/FormBuilder.types";
import {
  firstFormElements,
  FirstFormSchema,
  secondFormElements,
  SecondFormSchema,
  thirdFormElements,
  ThirdFormSchema,
} from "./FormSteps";

export const forms: FormSchema[] = [
  {
    header: "Заполните все данные в анкете и отправьте свой отзыв на проверку",
    elements: firstFormElements,
    schema: FirstFormSchema,
    position: "static",
  },
  {
    header: "Добавьте скриншот отзыва",
    elements: secondFormElements,
    schema: SecondFormSchema,
  },
  {
    header: "Для получения вознаграждения через СБП заполните поля",
    elements: thirdFormElements,
    schema: ThirdFormSchema as any,
  },
];
